import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { get } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faCircleCheck } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@/components/button";
import { FormInput, FormSelect } from "@/components/form";
import { showSuccessToast, showErrorToast } from "@/components/toast";
import { usePatientReports } from "@/hooks/report";
import { useSendSms } from "@/hooks/sms";
import { buildPreview, extractTokens, isTemplateSendable, getPreSendFailureMessage } from "@/utils/sms";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { SmsComposePreview } from "./sms-compose-preview";
/** Compose tab: pick an approved template + optional report, preview, and send. */
export function SmsComposeTab(_ref) {
  var _reports$data, _reports$data2;
  var patientUid = _ref.patientUid,
    firstName = _ref.firstName,
    numberOnFile = _ref.numberOnFile,
    optedOut = _ref.optedOut,
    templates = _ref.templates,
    isLoadingTemplates = _ref.isLoadingTemplates,
    onSent = _ref.onSent;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    templateId = _useState[0],
    setTemplateId = _useState[1];
  var _useState2 = useState(null),
    reportId = _useState2[0],
    setReportId = _useState2[1];
  var sendSms = useSendSms(patientUid);
  var reports = usePatientReports(patientUid);
  var sendableTemplates = useMemo(function () {
    return templates.filter(isTemplateSendable);
  }, [templates]);
  useEffect(function () {
    var firstTemplate = sendableTemplates[0];
    if (firstTemplate && !sendableTemplates.some(function (item) {
      return String(item.id) === templateId;
    })) {
      setTemplateId(String(firstTemplate.id));
    }
  }, [sendableTemplates, templateId]);
  var selectedTemplate = useMemo(function () {
    return sendableTemplates.find(function (item) {
      return String(item.id) === templateId;
    });
  }, [sendableTemplates, templateId]);
  var preview = useMemo(function () {
    return selectedTemplate ? buildPreview(selectedTemplate.body, {
      "@fname": (firstName === null || firstName === void 0 ? void 0 : firstName.trim()) || t("sms.compose.patient_name_placeholder", {
        defaultValue: "[patient name]"
      })
    }) : {
      text: "",
      segments: 1
    };
  }, [selectedTemplate, firstName, t]);
  var previewTokens = useMemo(function () {
    return selectedTemplate ? extractTokens(selectedTemplate.body) : [];
  }, [selectedTemplate]);
  var canSend = !optedOut && Boolean(numberOnFile) && Boolean(selectedTemplate) && !sendSms.isLoading;
  var onSend = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var httpStatus, reason, detail, message, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (selectedTemplate) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            trackEvent(ANALYTICS_EVENTS.SMS_SEND, {
              templateId: selectedTemplate.id
            });
            _context.p = 2;
            _context.n = 3;
            return sendSms.mutateAsync(_objectSpread({
              patient_id: patientUid,
              template_id: selectedTemplate.id,
              idempotency_key: crypto.randomUUID()
            }, reportId ? {
              report_id: reportId
            } : {}));
          case 3:
            trackEvent(ANALYTICS_EVENTS.SMS_SENT, {
              templateId: selectedTemplate.id
            });
            showSuccessToast(t("sms.toast.queued", {
              defaultValue: "SMS queued for delivery"
            }));
            onSent();
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            httpStatus = get(_t, ["response", "status"], 0);
            reason = get(_t, ["response", "data", "reason"], "");
            detail = get(_t, ["response", "data", "detail"], "");
            message = httpStatus === 409 ? detail || t("sms.error.duplicate", {
              defaultValue: "This message looks like a duplicate. Refresh and try again."
            }) : getPreSendFailureMessage(reason) || detail || t("sms.error.send_failed", {
              defaultValue: "Could not send SMS. Please try again."
            });
            trackEvent(ANALYTICS_EVENTS.SMS_SEND_FAILED, {
              reason: reason || httpStatus
            });
            showErrorToast(message);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function onSend() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (isLoadingTemplates) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center py-8",
      role: "status"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      className: "h-5 w-5 animate-spin text-sds-brand-default"
    }), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, t("loading", {
      defaultValue: "Loading…"
    })));
  }
  if (!sendableTemplates.length) {
    return /*#__PURE__*/React.createElement("div", {
      className: "rounded-sds-200 border border-sds-attention-secondary bg-sds-attention-tertiary p-3 text-style-body-small text-sds-attention-on-attention-tertiary"
    }, t("sms.compose.no_templates", {
      defaultValue: "No active SMS templates for this workspace. Add one in Settings · SMS templates and mark it active."
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, optedOut ? /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 border border-sds-urgent-secondary bg-sds-urgent-tertiary p-3 text-style-body-small text-sds-urgent-on-urgent-tertiary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-body-small-strong"
  }, t("sms.compose.opted_out_title", {
    defaultValue: "Patient has opted out of SMS."
  })), " ", t("sms.compose.opted_out_detail", {
    defaultValue: "No message can be sent. You can still reach them by phone or letter."
  })) : null, numberOnFile ? /*#__PURE__*/React.createElement(FormInput, {
    label: t("sms.compose.number_label", {
      defaultValue: "Mobile number on file"
    }),
    value: numberOnFile,
    readOnly: true,
    "data-testid": "sms-compose-number"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "rounded-sds-200 border border-sds-attention-secondary bg-sds-attention-tertiary p-3 text-style-body-small text-sds-attention-on-attention-tertiary"
  }, t("sms.compose.no_number", {
    defaultValue: "No mobile number on file. Add the patient's mobile number to send an SMS."
  })), /*#__PURE__*/React.createElement(FormSelect, {
    label: t("sms.compose.template_label", {
      defaultValue: "Template (approved only)"
    }),
    data: sendableTemplates.map(function (item) {
      return {
        value: String(item.id),
        label: item.name
      };
    }),
    value: templateId,
    disabled: optedOut,
    "data-testid": "sms-compose-template",
    onChange: function onChange(value) {
      setTemplateId(value);
      trackEvent(ANALYTICS_EVENTS.SMS_TEMPLATE_SELECT, {
        templateId: value
      });
    }
  }), ((_reports$data = reports.data) !== null && _reports$data !== void 0 ? _reports$data : []).length ? /*#__PURE__*/React.createElement(FormSelect, {
    label: t("sms.compose.attach_report_label", {
      defaultValue: "Attach report (optional)"
    }),
    data: [{
      value: "",
      label: t("sms.compose.no_report", {
        defaultValue: "No report"
      })
    }].concat(_toConsumableArray(((_reports$data2 = reports.data) !== null && _reports$data2 !== void 0 ? _reports$data2 : []).map(function (item) {
      return {
        value: String(item.id),
        label: item.heading || t("sms.compose.report_fallback", {
          defaultValue: "Report {{id}}",
          id: item.id
        })
      };
    }))),
    value: reportId !== null && reportId !== void 0 ? reportId : "",
    disabled: optedOut,
    "data-testid": "sms-compose-report",
    onChange: function onChange(value) {
      setReportId(value || null);
      trackEvent(ANALYTICS_EVENTS.SMS_REPORT_SELECT, {
        reportId: value
      });
    }
  }) : null, /*#__PURE__*/React.createElement(SmsComposePreview, {
    text: preview.text,
    segments: preview.segments,
    tokens: previewTokens
  }), !optedOut && canSend ? /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2 rounded-sds-200 border border-sds-success-secondary bg-sds-success-tertiary p-3 text-style-body-small-strong text-sds-success-on-success-tertiary"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faCircleCheck,
    className: "h-4 w-4 flex-shrink-0"
  }), t("sms.compose.opted_in_check", {
    defaultValue: "Patient opted in. Pre-send checks run server-side on send."
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "sms-compose-send",
    loading: sendSms.isLoading,
    disabled: !canSend,
    onClick: onSend
  }, t("sms.compose.send", {
    defaultValue: "Send SMS"
  }))));
}